import Vue from 'vue';
import Router from 'vue-router';
import docCookies from '../assets/js/utile.js';
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
};

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/commodity',
    name: 'commodity',
    component: () => import('@/pages/commodity/commodity')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/pages/commodity/detail')
  },
  {
    path: '/luckyDraw',
    name: 'luckyDraw',
    component: () => import('@/pages/luckyDraw/index')
  },
  {
    path: '/winnerList',
    name: 'winnerList',
    component: () => import('@/pages/luckyDraw/winnerList'),
    meta: {
      title: "中奖列表"
    },
  },
  {
    path: '/verificationCode',
    name: 'verificationCode',
    component: () => import('@/pages/luckyDraw/verificationCode')
  },
  {
    path: '/explosiveGoods/goldNote',
    name: 'picture',
    component: () => import('@/pages/explosiveGoods/goldNote')
  },
  {
    path: '/explosiveGoods/silverCertificate',
    name: 'picture',
    component: () => import('@/pages/explosiveGoods/silverCertificate')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/register/register')
  },
  {
    path: '/pullNew/pullNew',
    name: 'pullNew',
    component: () => import('@/pages/pullNew/pullNew')
  },
  {
    path: '/article/article',
    name: 'article',
    component: () => import('@/pages/article/article')
  },
  {
    path: '/preview/preview',
    name: 'preview',
    component: () => import('@/pages/preview/preview')
  },
  {
    path: '/preview/previewJf',
    name: 'previewJf',
    component: () => import('@/pages/preview/previewJf')
  },
  {
    path: '/preview/previewYk',
    name: 'previewYk',
    component: () => import('@/pages/preview/previewYk')
  },
  {
    path: '/preview/previewJfC',
    name: 'previewJfC',
    component: () => import('@/pages/preview/previewJfC')
  },
  {
    path: '/preview/previewYl',
    name: 'previewYl',
    component: () => import('@/pages/preview/previewYl')
  },
  {
    path: '/preview/previewShop',
    name: 'previewShop',
    component: () => import('@/pages/preview/previewShop')
  },
  {
    path: '/preview/previewMd',
    name: 'previewMd',
    component: () => import('@/pages/preview/previewMd')
  },
  {
    path: '/pay/index',
    name: 'payIndex',
    component: () => import('@/pages/pay/index')
  },
  {
    path: '/pay/success',
    name: 'success',
    component: () => import('@/pages/pay/success')
  },
  {
    path: '/pay/login',
    name: 'payLogin',
    component: () => import('@/pages/pay/login')
  },
  {
    path: '/redPacket/redPacket',
    name: 'redPacket',
    component: () => import('@/pages/redPacket/redPacket')
  },
  {
    path: '/redPacket/success',
    name: 'redPacketSuccess',
    component: () => import('@/pages/redPacket/success')
  },
  {
    path: '/scan',
    name: 'scanQrcodeIndex',
    component: () => import('@/pages/scanQrcode/index')
  },
  {
    path: '/scanQrcode/success',
    name: 'scanQrcodeSuccess',
    component: () => import('@/pages/scanQrcode/success')
  },
  {
    path: "/scanQrcode/addPhone",
    name: "scanQrcodeAddPhone",
    component: () => import('@/pages/scanQrcode/addPhone')
  },
  {
    path: "/scanRegisterNew/bindingPhone",
    name: "bindingPhone",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegisterNew/bindingPhone')
  },
  {
    path: "/scanRegisterNew/accountNumber",
    name: "accountNumber",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegisterNew/accountNumber')
  },
  {
    path: "/scanRegisterNew/seleAccount",
    name: "pay",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegisterNew/seleAccount')
  },
  {
    path: "/scanRegisterNew/success",
    name: "scanRegisterSuccess",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegisterNew/success')
  },
  {
    path: "/scanRegister/bindingPhone",
    name: "bindingPhone",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegister/bindingPhone')
  },
  {
    path: "/scanRegister/accountNumber",
    name: "accountNumber",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegister/accountNumber')
  },
  {
    path: "/scanRegister/pay",
    name: "pay",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegister/pay')
  },
  {
    path: "/scanRegister/success",
    name: "scanRegisterSuccess",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/scanRegister/success')
  },
  {
    path: "/extensionOpen/bindingPhone",
    name: "extensionBindingPhone",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/extensionOpen/bindingPhone')
  },
  {
    path: "/extensionOpen/accountNumber",
    name: "extensionAccountNumber",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/extensionOpen/accountNumber')
  },
  {
    path: "/extensionOpen/success",
    name: "extensionSuccess",
    meta: {
      title: "新店商商家"
    },
    component: () => import('@/pages/extensionOpen/success')
  },
  {
    path: '/logistics/logistics',
    name: 'logistics',
    component: () => import('@/pages/logistics/logistics')
  },
  {
    path: '/index',
    name: 'index',
    component: ()=> import ("@/pages/giftCard/index" ),
    meta:{
      title:"新店商礼品卡登录",
      auth:true,
      isReplace:false
    }
  },
  {
    path: '/goodsDetail',
    name: 'goodsDetail',
    component: ()=> import ("@/pages/giftCard/goodsDetail" ),
    meta:{
      title:"礼品卡兑换详情",
      auth:true,
      isReplace:false
    }
  },
  {
    path: '/confirmOrder',
    name: 'confirmOrder',
    component: ()=> import ("@/pages/giftCard/confirmOrder" ),
    meta:{
      title:"确认订单",
      auth:true,
      isReplace:false
    }
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: ()=> import ("@/pages/giftCard/addAddress" ),
    meta:{
      title:"收货地址",
      auth:true,
      isReplace:false
    }
  },
  {
    path: '/payResult',
    name: 'payResult',
    component: ()=> import ("@/pages/giftCard/payResult" ),
    meta:{
      title:"提交订单",
      auth:true,
      isReplace:false
    }
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: ()=> import ("@/pages/giftCard/orderDetail" ),
    meta:{
      title:"订单详情",
      auth:true,
      isReplace:false
    }
  }
  ],
  /**
   * 由于此处存在多个项目
   * 所以需要做登录鉴权的页面需要进行判断是否当前页面需要进行登录鉴权
   * 凡是在路由的meta里面，加了auth的页面证明当前页面需要进行登录方可使用，通过路由守卫进行登录鉴权
   */



  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : "";
  if(window.entryUrl===undefined){
    window.entryUrl = window.location.href;
  };
  if(to.meta.auth){
    if(to.path!=="/index"){
      if(docCookies.getItem("giftToken")){
        if(!to.meta.isReplace){
          next();
        }else{
          next(from.fullPath);
        }
      }else{
        next("/index")
      }
    }else{
      next();
    }
  }else{
    next();
  };
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js